import usePDFTheme from '@/utils/hooks/usePDFTheme';
import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { useMemo } from 'react';

interface PortfolioStatementPositionsHeaderProps {
    eyebrow: string;
    title: string;
}

const PortfolioStatementPositionsHeader = ({ eyebrow, title }: PortfolioStatementPositionsHeaderProps) => {
    const pdfTheme = usePDFTheme();

    const { base, palette, fontFamily } = pdfTheme;

    const styles = useMemo(() => {
        return StyleSheet.create({
            root: {
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
                marginBottom: 12
            },
            totalBlock: {
                flexDirection: 'row',
                alignItems: 'center'
            },
            totalLabel: {
                fontSize: 7,
                letterSpacing: 1.4,
                marginRight: 9,
                color: palette.neutral,
                fontFamily,
                fontWeight: 500
            },
            totalValue: {
                fontSize: 13,
                color: palette.ink,
                fontFamily,
                fontWeight: 600
            }
        });
    }, [fontFamily, palette]);
    return (
        <View style={styles.root}>
            <View>
                <Text style={base.eyebrow}>{eyebrow}</Text>
                <Text style={base.sectionTitle}>{title}</Text>
            </View>
        </View>
    );
};

export default PortfolioStatementPositionsHeader;
